module.exports = __webpack_public_path__ + "img/cover.e5e2fcee.jpg";